module.exports = __webpack_public_path__ + "static/assets/92160d8614e405f7cfb6e19633e5c317.png";